import { TaskDueDateOffset } from '../CRMIntegrationTaskSettings'

export type WealthboxInboundContactSyncSettingsFilters = {
  active?: boolean
  contactType?: string
  tags?: string[]
  type?: string
}

export type WealthboxInboundContactSyncSettings = {
  autoSync: boolean
  filters: WealthboxInboundContactSyncSettingsFilters
  tierTags?: string[]
}

export type WealthboxInboundCalendarSyncSettings = {
  enabled: boolean
}

export type WealthboxInboundSyncSettings = {
  contact: WealthboxInboundContactSyncSettings
  calendar: WealthboxInboundCalendarSyncSettings
}

export type WealthboxSettingsFormValues = {
  inbound: WealthboxInboundSyncSettings
  taskDueDateOffset?: TaskDueDateOffset
}

export const wealthboxSettingsDefaultValues: WealthboxSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
      filters: {},
    },
    calendar: {
      enabled: false,
    },
  },
  taskDueDateOffset: {
    value: 1,
    unit: 'weeks',
  },
}
